import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from 'components/elements/buttons/Button';

import './AddPaymentProviderSelectStep.css';

const providers = [
  {
    title: 'Stripe',
    paymentSystem: 'stripe',
    isAvailable: true,
  },
  {
    title: 'Square',
    paymentSystem: 'square',
    isAvailable: false,
  },
  {
    title: 'PayPal',
    paymentSystem: 'paypal',
    isAvailable: false,
  },
];

function AddPaymentProviderSelectStep(props) {
  const { onClose, setActiveStep } = props;
  const [selectedProvider, setSelectedProvider] = useState(null);
  const { t } = useTranslation();

  return (
    <div className="add-payment-provider-select-step__component">
      <div className="header">{t("Select payment provider")}</div>
      <div className="providers-wrapper">
        {providers.map(item => (
          <div
            className={`provider-item${!item.isAvailable ?
              ' disabled' : ''}${selectedProvider === item.paymentSystem ?
              ' active' : ''}`}
            onClick={() => {
              if (!item.isAvailable) return;
              setSelectedProvider(item.paymentSystem);
            }}
            role="button"
            tabIndex={-1}
          >
            <div className={`logo ${item.paymentSystem}${item.isAvailable ? ' available' : ''}`} />
            <div className="title">{item.title}</div>
            <div className="is-available">
              {item.isAvailable ? '>' : t("Coming Soon")}
            </div>
          </div>
        ))}
      </div>
      <div className="buttons-block">
        <Button
          small
          borderedBlue
          onClick={onClose}
        >
          {t("Cancel")}
        </Button>
        <Button
          small
          disabled={!selectedProvider}
          onClick={() => setActiveStep('stripe-step-1')}
        >
          {t("Next")}
        </Button>
      </div>
    </div>
  );
}

AddPaymentProviderSelectStep.propTypes = {
  onClose: PropTypes.func.isRequired,
  setActiveStep: PropTypes.func.isRequired,
};

export default AddPaymentProviderSelectStep;
